<template>
  <div class="fan-search-col content jr-select-content">
    <span class="source_span" v-if="title">{{title}}</span>
    <template v-if="selectType === 'select'">
      <el-select
        :multiple="isMul"
        v-model="selectValue"
        v-bind="$attrs"
        v-on="$listeners"
        :loading="loadingList"
        :style="selectStyle"
        class="select-box"
      >
        <el-option
          v-for="(item, index) in selectOptions"
          :key="index"
          :label="item[propsConfig.label]"
          :value="isBindObj ? item : item[propsConfig.value]"
          :disabled="item.disabled || false"
        >
        </el-option>
      </el-select>
    </template>
    <template v-if="selectType === 'cascader'">
      <el-cascader
        :options="cascaderOptions"
        :size="formSize"
        v-model="cascaderValue"
        :loading="loadingList"
        :style="selectStyle"
        v-bind="$attrs"
        v-on="$listeners"
        ref="cascaderRef"
      />
    </template>
  </div>
</template>

<script>
import { recursiveTree } from '@/utils/tools';
import { getSourceOfUser } from '@/api/global';
import * as _ from 'lodash';

export default {
  name: 'baseSelect',
  data() {
    return {
      selectValue: this.value,
      cascaderValue: this.value,
      loadingList: false,
      sourceList: [],
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    // 默认值
    value: {
      type: [Number, String, Array, Object],
    },
    isMul: {
      type: Boolean,
      default: false,
    },
    // 字段类型
    dictionaryType: {
      type: String,
      default: '',
    },
    noInOptionItem: {
      // 选项过滤名单（需要过滤掉的选项ID组合） eg: ['1']
      type: Array,
      default: () => ([]),
    },
    // 是否绑定整个对象
    isBindObj: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    selectStyle: {
      type: String,
      default: 'max-width: 110px;',
    },
    // 参数值
    propsConfig: {
      type: Object,
      default: () => ({
        value: 'value',
        label: 'label',
      }),
    },
    // 选项下拉类型
    selectType: {
      type: String,
      default: 'select',
    },
    isSource: {
      type: Boolean,
      default: false,
    },
    hasAll: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getCheckedNodes() {
      return this.$refs.cascaderRef.getCheckedNodes();
    },
    selectOptions() {
      // 如果有静态的options，就不通过接口获取
      if (this.options.length > 0) {
        return this.options;
      }
      const { dictData = {} } = this.$store.state.dictionary;
      const options = _.cloneDeep(dictData[this.dictionaryType] || []);
      if (this.hasAll) {
        options.unshift({
          value: '',
          label: '全部',
        });
      }
      return options;
    },
    cascaderOptions() {
      // 如果有静态的options，就不通过接口获取
      if (this.options.length > 0) {
        return this.options;
      }
      if (this.dictionaryType) {
        const { dictData = {} } = this.$store.state.dictionary;
        const options = _.cloneDeep(dictData[this.dictionaryType] || []);
        if (this.hasAll) {
          options.unshift({
            value: '',
            label: '全部',
          });
        }
        return options;
      }

      return this.sourceList;
    },
  },
  watch: {
    value: {
      handler(val) {
        if (this.selectType === 'cascader') {
          this.cascaderValue = val;
        } else {
          this.selectValue = val;
        }
      },
    },
    cascaderValue(newVal) {
      this.$emit('input', newVal);
    },
  },
  mounted() {
    if (this.selectType === 'select') {
      this.init();
    }
    if (this.selectType === 'cascader') {
      this.cascaderInit();
    }
  },
  methods: {
    init() {
      const { dictionaryType } = this;
      if (!dictionaryType) {
        console.log('没有字典');
      } else {
        // 获取字典
        this.loadingList = true;
        try {
          if (dictionaryType === '') return; // dictionaryType为空时,不请求
          this.$store.dispatch('dictionary/getDictionary', { type: dictionaryType });
        } finally {
          this.loadingList = false;
        }
      }
    },
    cascaderInit() {
      const { dictionaryType } = this;
      if (dictionaryType) {
        // 获取字典
        this.loadingList = true;
        try {
          this.$store.dispatch('dictionary/getDictionary', { type: dictionaryType });
        } finally {
          this.loadingList = false;
        }
        return;
      }
      if (this.isSource) {
        this._getSourceOfUser();
      }
    },
    async _getSourceOfUser() {
      // 归属业务接口
      const res = await getSourceOfUser();
      const list = recursiveTree(res?.data || [], 0);
      const all = [
        {
          id: '',
          categoryNum: 'all',
          categoryName: '全部业务',
        },
      ];
      if (this.hasAll) {
        this.sourceList = [...all, ...(list || [])];
      } else {
        this.sourceList = list || [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 0;
  margin-right: 32px;
}
.select-box {
  width: 100%;
}
</style>
